import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { Label } from "@atlaskit/form";

const HttpStatusConditionPanel = ({ httpCondition }) => {
  const [value, setValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (httpCondition && httpCondition.value !== value) setValue(httpCondition.value);
  }, [httpCondition]);

  const changeValue = (e) => {
    setValue(e.target.value);
    httpCondition.value = e.target.value;
    dispatch(setEditorSaved(false));
  };

  return (
    <>
      <Label>HTTP Status codes (comma separaded list is allowed)</Label>
      <Textfield value={value} isCompact onChange={changeValue} width="250" />
    </>
  );
};

export default HttpStatusConditionPanel;
